document.addEventListener('DOMContentLoaded', function () {

  // aa UTILITIES aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  function showToast(msg, isError) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.style.background = isError ? '#ef4444' : 'var(--color-accent)';
    toast.style.color      = isError ? '#fff'    : 'var(--color-btn-text)';
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.querySelectorAll('.mobile-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // aa SEARCH PANEL (desktop) aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  var searchToggle = document.getElementById('search-toggle');
  var searchPanel  = document.getElementById('search-panel');
  var searchClose  = document.getElementById('search-close');
  var searchInput  = document.getElementById('search-input');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    searchToggle.classList.add('is-active');
    if (searchInput) setTimeout(function() { searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.classList.remove('is-active');
  }
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function() {
      searchPanel.hidden ? openSearch() : closeSearch();
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function() {
      closeSearch();
      if (searchToggle) searchToggle.focus();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchPanel && !searchPanel.hidden) closeSearch();
  });

  // aa MOBILE NAV aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.getElementById('mobile-nav');

  function openNav() {
    if (!mobileNav || !hamburger) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Inchide meniu');
    document.body.classList.add('nav-open');
  }

  function closeNav() {
    if (!mobileNav || !hamburger) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'Deschide meniu');
    document.body.classList.remove('nav-open');
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.contains('is-open') ? closeNav() : openNav();
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
  }

  // aa MOBILE ACCORDION aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  document.querySelectorAll('[data-accordion]').forEach(function (item) {
    var toggle  = item.querySelector('.mobile-nav__toggle');
    var submenu = item.querySelector('.mobile-nav__submenu');
    if (!toggle || !submenu) return;
    toggle.addEventListener('click', function () {
      var isOpen = !submenu.hidden;
      submenu.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.classList.toggle('is-open', !isOpen);
    });
  });

  // aa HERO DIRECT CHECKOUT aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  document.querySelectorAll('.hero-checkout-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.dataset.variant, 10);
      if (!variantId) { window.location.href = '/checkout'; return; }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart-add-failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          showToast('Eroare. Incearca din nou.', true);
        });
    });
  });

  // aa AJAX CART (product cards) aaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  document.querySelectorAll('.card__btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = parseInt(btn.dataset.id, 10);
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent  = '✓';
      btn.disabled     = true;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add-failed');
          updateCartBadge();
          showToast('Adaugat in cos!');
        })
        .catch(function () {
          showToast('Eroare. Incearca din nou.', true);
        })
        .finally(function () {
          btn.textContent = originalText;
          btn.disabled    = false;
        });
    });
  });

  // aa ORDER NOW (product cards, collection) aaaaaaaaaaaaaaaaaaaa
  document.querySelectorAll('.card__order-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.dataset.id, 10);
      if (!variantId || btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add-failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.dataset.busy = '0';
          showToast('Eroare. Incearca din nou.', true);
        });
    });
  });

  // aa PRODUCT PAGE aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  (function () {
    var variantsEl = document.getElementById('product-variants-json');
    if (!variantsEl) return;

    var variants     = JSON.parse(variantsEl.textContent);
    var form         = document.getElementById('product-form');
    var atcBtn       = document.getElementById('atc-btn');
    var priceEl      = document.getElementById('product-price');
    var compareEl    = document.getElementById('product-compare');
    var saveEl       = document.getElementById('product-save');
    var availEl      = document.getElementById('product-avail');
    var variantInput = document.getElementById('variant-id');
    var stickyPrice  = document.getElementById('sticky-price');
    var stickyBtnEl  = document.getElementById('sticky-atc-btn');

    var atcLabelAvail   = atcBtn ? atcBtn.textContent.trim() : 'Adauga in cos';
    var stickyLabelAvail = stickyBtnEl ? stickyBtnEl.textContent.trim() : atcLabelAvail;
    var atcLabelUnavail = 'Indisponibil';

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' MDL';
    }

    function getSelectedOptions() {
      if (!form) return [];
      var result = [];
      form.querySelectorAll('.product-form__radio:checked').forEach(function (el) {
        result[parseInt(el.dataset.optionPos, 10)] = el.value;
      });
      return result;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateVariantUI(v) {
      if (!v) return;
      if (variantInput) variantInput.value = v.id;

      var price = formatMoney(v.price);
      if (priceEl)    priceEl.textContent    = price;
      if (stickyPrice) stickyPrice.textContent = price;

      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (compareEl) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.style.display = ''; }
        if (saveEl) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          saveEl.textContent = '-' + pct + '%';
          saveEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl)    saveEl.style.display    = 'none';
      }

      if (atcBtn) {
        atcBtn.disabled    = !v.available;
        atcBtn.textContent = v.available ? atcLabelAvail : atcLabelUnavail;
      }

      if (stickyBtnEl) {
        stickyBtnEl.disabled    = !v.available;
        stickyBtnEl.textContent = v.available ? stickyLabelAvail : atcLabelUnavail;
      }

      if (availEl) {
        availEl.innerHTML = v.available
          ? '<span class="avail-dot"></span> In stoc'
          : '<span class="avail-dot avail-dot--out"></span> Indisponibil';
        availEl.classList.toggle('product-info__avail--out', !v.available);
      }
    }

    // Variant radio change
    if (form) {
      form.querySelectorAll('.product-form__radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var label = document.getElementById('opt-val-' + radio.dataset.optionPos);
          if (label) label.textContent = radio.value;
          var v = findVariant(getSelectedOptions());
          if (v) updateVariantUI(v);
        });
      });

      // AJAX add-to-cart — intercept form submit
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atcBtn || atcBtn.disabled) return;

        var vid = parseInt((variantInput ? variantInput.value : ''), 10);
        var qty = parseInt((document.getElementById('qty-input') ? document.getElementById('qty-input').value : '1'), 10) || 1;
        if (!vid) return;

        var originalText = atcBtn.textContent;
        atcBtn.disabled   = true;
        atcBtn.textContent = '...';
        if (stickyBtnEl) { stickyBtnEl.disabled = true; stickyBtnEl.textContent = '...'; }

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: vid, quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add-failed');
            updateCartBadge();
            showToast('Adaugat in cos!');
          })
          .catch(function () {
            showToast('Eroare. Incearca din nou.', true);
          })
          .finally(function () {
            atcBtn.disabled   = false;
            atcBtn.textContent = originalText;
            if (stickyBtnEl) { stickyBtnEl.disabled = false; stickyBtnEl.textContent = stickyLabelAvail; }
          });
      });
    }

    // Quantity stepper
    var qtyInput = document.getElementById('qty-input');
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = btn.dataset.action === 'plus'
          ? Math.min(val + 1, 99)
          : Math.max(val - 1, 1);
      });
    });

    // Gallery
    var mainImg    = document.getElementById('main-product-img');
    var thumbs     = Array.from(document.querySelectorAll('.product-gallery__thumb'));
    var currentIdx = 0;
    var galleryCurrent = document.getElementById('gallery-current');

    function showGalleryImage(idx) {
      if (!thumbs.length) return;
      currentIdx = (idx + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIdx];
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
        mainImg.onload = function () { mainImg.style.opacity = '1'; };
      }
      if (galleryCurrent) galleryCurrent.textContent = currentIdx + 1;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showGalleryImage(i); });
    });

    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { showGalleryImage(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showGalleryImage(currentIdx + 1); });

    var galleryMain = document.getElementById('product-gallery-main');
    if (galleryMain) {
      var touchStartX = 0;
      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) showGalleryImage(diff > 0 ? currentIdx + 1 : currentIdx - 1);
      }, { passive: true });
    }

    // Buy Now button
    var buyNowBtn = document.getElementById('buy-now-btn');
    if (buyNowBtn) {
      var buyNowLabel = buyNowBtn.textContent.trim();
      buyNowBtn.addEventListener('click', function () {
        var vid = parseInt((variantInput ? variantInput.value : ''), 10);
        var qty = parseInt((qtyInput ? qtyInput.value : '1'), 10) || 1;
        if (!vid) return;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add-failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = buyNowLabel;
            showToast('Eroare. Incearca din nou.', true);
          });
      });
    }

    // Sticky ATC visibility
    var stickyBar = document.getElementById('sticky-atc');
    if (atcBtn && stickyBar) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entries[0].isIntersecting));
      }, { threshold: 0 }).observe(atcBtn);
    }
    if (stickyBtnEl && atcBtn) {
      stickyBtnEl.addEventListener('click', function () { atcBtn.click(); });
    }

    // Related products
    var recsSection = document.getElementById('product-recommendations');
    if (recsSection && recsSection.dataset.url) {
      fetch(recsSection.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.getElementById('product-recommendations');
          if (inner) recsSection.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }
  })();

  // aa CART PAGE aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  (function () {
    function cartMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' MDL';
    }

    var totalEl    = document.querySelector('.cart-total__amount');
    var termsCheck = document.getElementById('cart-terms-check');
    var checkoutBtn= document.getElementById('cart-checkout-btn');
    var termsError = document.getElementById('cart-terms-error');

    // Terms checkbox a enable/disable checkout
    if (termsCheck && checkoutBtn) {
      termsCheck.addEventListener('change', function () {
        var ok = termsCheck.checked;
        checkoutBtn.classList.toggle('is-disabled', !ok);
        checkoutBtn.setAttribute('aria-disabled', String(!ok));
        checkoutBtn.setAttribute('tabindex', ok ? '0' : '-1');
        if (ok && termsError) termsError.style.display = 'none';
      });
      checkoutBtn.addEventListener('click', function (e) {
        if (!termsCheck.checked) {
          e.preventDefault();
          if (termsError) termsError.style.display = '';
        }
      });
    }

    // Qty steppers + remove buttons
    document.querySelectorAll('.cart-item').forEach(function (item) {
      var key    = item.dataset.key;
      var valEl  = item.querySelector('.cart-qty__val');
      var totEl  = item.querySelector('.cart-item__total');

      function changeQty(qty) {
        fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart || typeof cart.total_price !== 'number') { location.reload(); return; }
            if (qty === 0) {
              item.remove();
              if (cart.item_count === 0) { location.reload(); return; }
            } else {
              if (valEl) valEl.textContent = qty;
              var lineItem = cart.items.find(function (i) { return i.key === key; });
              if (lineItem && totEl) totEl.textContent = cartMoney(lineItem.line_price);
            }
            if (totalEl) totalEl.textContent = cartMoney(cart.total_price);
            updateCartBadge();
          })
          .catch(function () { showToast('Eroare. Incearca din nou.', true); });
      }

      item.querySelectorAll('.cart-qty__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(valEl ? valEl.textContent : '1', 10);
          if (btn.dataset.action === 'minus' && current === 1) {
            if (!window.confirm('Stergi acest produs din cos?')) return;
            changeQty(0);
            return;
          }
          changeQty(btn.dataset.action === 'plus' ? current + 1 : Math.max(current - 1, 0));
        });
      });

      var removeBtn = item.querySelector('.cart-remove-btn');
      if (removeBtn) {
        removeBtn.addEventListener('click', function () { changeQty(0); });
      }
    });
  })();

  // aa PREDICTIVE SEARCH aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  (function () {
    function moneyFormat(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' MDL';
    }

    function setupPredictive(inputEl, resultsEl) {
      if (!inputEl || !resultsEl) return;
      var timer;
      var currentQuery = '';

      function clearResults() {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        currentQuery = '';
      }

      function renderResults(data, q) {
        if (q !== currentQuery) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        resultsEl.innerHTML = '';

        if (!products.length) {
          var empty = document.createElement('div');
          empty.className = 'search-results__empty';
          empty.textContent = 'Niciun produs gasit';
          resultsEl.appendChild(empty);
          resultsEl.hidden = false;
          return;
        }

        products.forEach(function (p) {
          var a = document.createElement('a');
          a.href = p.url;
          a.className = 'search-result';
          a.setAttribute('role', 'option');

          var imgSrc = p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=104' : '';
          var imgAlt = (p.featured_image && p.featured_image.alt) || p.title;
          var imgEl = imgSrc
            ? '<img class="search-result__img" src="' + imgSrc + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '" width="52" height="52" loading="lazy">'
            : '<div class="search-result__img"></div>';

          var price = '';
          if (p.variants && p.variants[0] && p.variants[0].price) {
            price = '<div class="search-result__price">' + moneyFormat(p.variants[0].price) + '</div>';
          }

          a.innerHTML = imgEl + '<div class="search-result__info"><div class="search-result__title">' + p.title + '</div>' + price + '</div>';
          resultsEl.appendChild(a);
        });

        var footer = document.createElement('div');
        footer.className = 'search-results__footer';
        var link = document.createElement('a');
        link.href = '/search?type=product&q=' + encodeURIComponent(q);
        link.textContent = 'Vezi toate rezultatele';
        footer.appendChild(link);
        resultsEl.appendChild(footer);
        resultsEl.hidden = false;
      }

      inputEl.addEventListener('input', function () {
        clearTimeout(timer);
        var q = inputEl.value.trim();
        if (q.length < 2) { clearResults(); return; }
        currentQuery = q;
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (data) { renderResults(data, q); })
            .catch(function () {});
        }, 280);
      });

      document.addEventListener('click', function (e) {
        if (!inputEl.contains(e.target) && !resultsEl.contains(e.target)) clearResults();
      });

      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { clearResults(); inputEl.blur(); }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var first = resultsEl.querySelector('.search-result');
          if (first) first.focus();
        }
      });

      resultsEl.addEventListener('keydown', function (e) {
        var links = Array.from(resultsEl.querySelectorAll('.search-result'));
        var idx = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); if (links[idx + 1]) links[idx + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); idx > 0 ? links[idx - 1].focus() : inputEl.focus(); }
        if (e.key === 'Escape') { clearResults(); inputEl.focus(); }
      });
    }

    setupPredictive(
      document.getElementById('search-input'),
      document.getElementById('search-results')
    );
    setupPredictive(
      document.getElementById('mobile-search-input'),
      document.getElementById('mobile-search-results')
    );
  })();

  // aa PRODUCT FILTER aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
  var filterBtns   = document.querySelectorAll('.filter-btn');
  var productCards = document.querySelectorAll('.product-card');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tag = btn.dataset.filter;
      filterBtns.forEach(function (b) { b.classList.toggle('active', b.dataset.filter === tag); });
      productCards.forEach(function (card) {
        var show = tag === 'all' || (card.dataset.tags && card.dataset.tags.includes(tag));
        card.style.display = show ? '' : 'none';
        if (show) {
          card.style.opacity = '0';
          requestAnimationFrame(function () {
            card.style.transition = 'opacity 0.3s';
            card.style.opacity = '1';
          });
        }
      });
    });
  });

});
